import { useIntl } from "react-intl";
import { CoinPriceTextFormat } from "@lib/components/MiniComponents/Others";
import { InvoiceListResponse, WalletAddressType } from "@lib/types";
import { Table, Typography } from "antd";
import useScreen from "@lib/hooks/useScreen";

type Props = {
  data: InvoiceListResponse;
};

export default function TableSummary({ data }: Props) {
  const { messages } = useIntl();
  const { isMobile } = useScreen();

  return (
    <Table.Summary>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} />
        <Table.Summary.Cell index={1} />
        <Table.Summary.Cell index={2}>
          <Typography.Text strong>
            {messages["common.pageTotal"] as string}
          </Typography.Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3}>
          <CoinPriceTextFormat
            amount={data?.totalAmount || 0}
            showCurrency={WalletAddressType.USDT}
            showCurrencyImage
            bold
            align={isMobile ? "left" : "right"}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4}>
          <CoinPriceTextFormat
            amount={data?.totalPaid || 0}
            showCurrency={WalletAddressType.USDT}
            bold
            align={isMobile ? "left" : "right"}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5}>
          <CoinPriceTextFormat
            amount={data?.totalRemainingAmount || 0}
            showCurrency={WalletAddressType.USDT}
            bold
            align={isMobile ? "left" : "right"}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6} colSpan={10} />
      </Table.Summary.Row>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} />
        <Table.Summary.Cell index={1} />
        <Table.Summary.Cell index={2}>
          <Typography.Text strong>
            {messages["common.grandTotal"] as string}
          </Typography.Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3}>
          <CoinPriceTextFormat
            amount={data?.summary?.amount || 0}
            showCurrency={WalletAddressType.USDT}
            showCurrencyImage
            bold
            align={isMobile ? "left" : "right"}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4}>
          <CoinPriceTextFormat
            amount={data?.summary?.paid || 0}
            showCurrency={WalletAddressType.USDT}
            bold
            align={isMobile ? "left" : "right"}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5}>
          <CoinPriceTextFormat
            amount={data?.summary?.remainingAmount || 0}
            showCurrency={WalletAddressType.USDT}
            bold
            align={isMobile ? "left" : "right"}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6} colSpan={10} />
      </Table.Summary.Row>
    </Table.Summary>
  );
}
